import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useStore } from "@/lib/store";
import { b64, fmtTime } from "@/lib/xc";

const LEAD_MS = 60000;

export function makeReminder(channel, prog) {
  return {
    key: `${channel.id}:${prog.start_timestamp}`,
    channel,
    title: b64(prog.title),
    start: Number(prog.start_timestamp),
    stop: Number(prog.stop_timestamp),
  };
}

export function useToggleReminder() {
  const { toggleReminder } = useStore();
  return (r) => {
    const added = toggleReminder(r);
    if (added && "Notification" in window && Notification.permission === "default") Notification.requestPermission();
    toast(added ? `Reminder set: ${r.title} at ${fmtTime(r.start)}` : "Reminder removed");
    return added;
  };
}

export default function ReminderWatcher() {
  const { reminders, removeReminders } = useStore();
  const nav = useNavigate();
  useEffect(() => {
    const check = () => {
      const now = Date.now();
      const due = reminders.filter((r) => r.start * 1000 - LEAD_MS <= now);
      if (!due.length) return;
      due.forEach((r) => {
        if (r.stop * 1000 < now) return;
        const watch = () => nav("/live", { state: { channel: r.channel } });
        const started = r.start * 1000 <= now;
        const msg = `${r.title} ${started ? "is on now" : "starts in a minute"} on ${r.channel.name}`;
        toast(msg, { duration: 60000, action: { label: "Watch now", onClick: watch } });
        if ("Notification" in window && Notification.permission === "granted") {
          const n = new Notification("XC Player reminder", { body: msg, icon: "/icon-192.png", tag: r.key });
          n.onclick = () => {
            window.focus();
            watch();
            n.close();
          };
        }
      });
      removeReminders(due.map((r) => r.key));
    };
    check();
    const t = setInterval(check, 10000);
    return () => clearInterval(t);
  }, [reminders, removeReminders, nav]);
  return null;
}
